import { render, staticRenderFns } from "./PowerAndWorking.vue?vue&type=template&id=12c98a47&scoped=true"
import script from "./PowerAndWorking.vue?vue&type=script&lang=js"
export * from "./PowerAndWorking.vue?vue&type=script&lang=js"
import style0 from "./PowerAndWorking.vue?vue&type=style&index=0&id=12c98a47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c98a47",
  null
  
)

export default component.exports